module.exports = __webpack_public_path__ + "img/Pickup Icon - white.6be814b5.svg";